import { useConstructorContextState } from './useConstructorContextState';
import { get } from 'lodash';

export const useGetSearchParams = (): Record<string, any> => {
  const state = useConstructorContextState();

  return get(state, 'searchParams', {});
};
